<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    width="1000px"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="150px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-divider content-position="left">基础信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="捐赠者：" prop="Name">
              <el-input
                v-model="dataForm.Name"
                clearable
                placeholder="请输入捐赠者"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="捐赠者类型：" prop="Donation">
              <el-radio-group v-model="dataForm.Donation">
                <el-radio :label="1">个人</el-radio>
                <el-radio :label="2">企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="捐赠时间：" prop="FinishTime">
              <el-date-picker
                 style="width:100%"
                 v-model="dataForm.FinishTime"
                 type="datetime"
                 value-format="timestamp"
                 placeholder="选择日期"
               ></el-date-picker>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="捐赠者电话：">
              <el-input
                v-model="dataForm.Phone"
                clearable
                placeholder="请输入捐赠者电话"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="捐赠项目：" prop="ProjectName">
              <el-select
              style="width:100%"
            placeholder="请选择"
            v-model="dataForm.ProjectName"
            allow-create filterable clearable
          >
            <el-option
              v-for="item in projectNameOptions"
              :key="item.ProjectCode"
              :label="item.ProjectName"
              :value="item.ProjectName"
            ></el-option>
          </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="配送方式：" prop="MailingType">
              <el-radio-group v-model="dataForm.MailingType">
                <el-radio :label="1">快递邮寄</el-radio>
                <el-radio :label="2">送货上门</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否开票：" prop="IsInvoice">
              <el-radio-group v-model="dataForm.IsInvoice">
                <el-radio :label="true">需要</el-radio>
                <el-radio :label="false">不需要</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="捐赠留言：" prop="Remark">
              <el-input
                type="textarea"
                :rows="3"
                v-model="dataForm.Remark"
                clearable
                placeholder="请输入捐赠留言"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">物品信息</el-divider>
        <div style="margin-bottom: 10px;">
          <el-button size="small" icon="el-icon-plus" type="danger" @click="addmaterialsform"
            >新增
          </el-button>
        </div>
        <el-table :data="materialsform" border style="width: 100%">
          <el-table-column
            prop="MaterialName"
            label="物品名称"
            min-width="180"
          />
          <el-table-column prop="MaterialType" align="center" label="品牌" width="180" :show-overflow-tooltip="true" />
          <el-table-column prop="Unit" label="规格" align="center" width="120" :show-overflow-tooltip="true" />
          <el-table-column prop="UnitPrice" align="center" label="单价" width="140" />
          <el-table-column prop="Number" align="center" label="数量" width="130" />
          <el-table-column prop="action" align="center" label="操作" width="130">
            <template slot-scope="scope">
              <el-button
                @click="editmaterialsform(scope.row, scope.$index)"
                type="text"
                size="mini"
                >编辑
              </el-button>
              <el-divider direction="vertical" />
              <el-button slot="reference" type="text" size="mini" @click="deletematerialsform(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <DetailEdit
        v-if="formVisible"
        :detailForm="detailForm"
        :detailTital="detailTital"
        @detailFormCallBack="detailFormCallBack"
      >
      </DetailEdit>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import DetailEdit from "@/modules/zjrc/pages/donation/donationmaterials/detail";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {
        Donation: {
          required: true,
          message: "请选择捐赠者类型",
          trigger: "blur",
        },
        Name: {
          required: true,
          message: "请输入捐赠者",
          trigger: "blur",
        },
        ProjectName: {
          required: true,
          message: "请输入捐赠项目",
          trigger: "blur",
        },
        MailingType: {
          required: true,
          message: "请选择配送方式",
          trigger: "blur",
        },
        FinishTime: {
          required: true,
          message: "请选择捐赠时间",
          trigger: "blur",
        },
        MaterialName: {
          required: true,
          message: "请添加物品信息",
          trigger: "blur",
        },
      },
      isConfirm: false,
      formVisible: false, //弹窗控制
      donatorTypeOptions: [
        { value: 1, label: "个人" },
        { value: 2, label: "企业" },
      ], //捐赠者类型
      projectNameOptions: [], //捐赠项目
      materialsform: [], //物品信息数组
      detailForm: {}, //物品信息对象
      index: 0, //物品数组序号
      detailTital: "", //详情标题
      dataForm: {},
    };
  },
  mounted() {
    this.getProjectNameOptions();
  },
  components: {
    OfDialog,
    DetailEdit,
  },
  methods: {
    onCancel(){
      debugger
    },
    //捐赠项目选择
    change(id) {
      this.projectNameOptions.forEach((item) => {
        if (item.Id === id) {
          this.dataForm.ProjectName = item.ProjectName;
        }
      });
    },
    //新增
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.FinishTime = params.FinishTime / 1000;
          params.MaterialsList = this.materialsform;
          api
            .SaveDonationMateials(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //获取项目信息
    getProjectNameOptions() {
      api.QueryPublicWelfareAll().then((res) => {
        if (res.data.Code === 0) {
          this.projectNameOptions = res.data.Data;
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //添加物品信息
    addmaterialsform() {
      this.detailTital = "新增物品信息";
      this.index = null;
      this.detailForm = {};
      this.formVisible = true;
    },
    //编辑物品信息
    editmaterialsform(rowData, index) {
      this.detailTital = "编辑物品信息";
      this.index = index;
      this.detailForm = rowData;
      this.formVisible = true;
    },
    //删除物品信息
    deletematerialsform(index) {
      this.materialsform.splice(index, 1);
    },
    //添加物品回调
    detailFormCallBack(rtnData) {
      if (rtnData) {
        if (this.index != null) {
          this.materialsform[this.index] = rtnData;
        } else {
          this.materialsform.push(rtnData);
        }
      }
      this.formVisible = false;
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}

.cardbutton {
  float: right;
}
.el-dialog-div {
  height: 70vh;
  overflow: auto;
}
</style>

<style>
.hide .el-button--primary {
  display: none;
}
</style>
